var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoInverseButtonActionSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "White_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.96,0H3.04C1.38,0,.04,1.35.04,3v14c0,1.65,1.35,3,3,3h20.92c1.65,0,3-1.35,3-3V3C26.96,1.35,25.62,0,23.96,0ZM23.33,2l-9.83,10.53L3.67,2h19.65ZM23.96,18H3.04c-.55,0-1-.45-1-1V3.18l10.73,11.5c.19.2.45.32.73.32s.54-.12.73-.32L24.96,3.18v13.82c0,.55-.45,1-1,1Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoInverseButtonActionSend);
export default __webpack_public_path__ + "static/media/kb-designer-ico-inverse-button-action-send.5bad9fbb1baaaaee2df05c6f13f55647.svg";
export { ForwardRef as ReactComponent };